<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em>Approval Date</em>
				<CustomDatePicker v-model="param.date" />
				<sales-group v-model="param.salesGroupCode" />
				<em class="lt_text">Sort</em>
				<span class="int_type_no_border mgr_5">
					<select v-model="param.sort" class="tbl_select">
						<option value="sc">Sales Group Code</option>
						<option value="in">Item Name</option>
					</select>
				</span>
				<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
			</div>
		</div>
		<div class="fixed-table-container">
			<div class="table-wrapper" style="height: 90%">
				<table class="list_tbl sticky_list_tbl">
					<colgroup>
						<col style="width: 7%" />
						<col style="width: 7%" />
						<col style="width: 7%" />
						<col style="width: 7%" />
						<col style="width: 7%" />
						<col />
						<col style="width: 7%" />
						<col style="width: 10%" />
						<col style="width: 10%" />
						<col style="width: 10%" />
						<col style="width: 10%" />
					</colgroup>
					<thead>
						<tr>
							<th>SO NO</th>
							<th>Sales Name</th>
							<th>Group</th>
							<th>Dept A</th>
							<th>Dept B</th>
							<th>{{ headers.class }} Code</th>
							<th>Name</th>
							<th>Color Code</th>
							<th>On Hand</th>
							<th>Ship Date</th>
							<th>Arrive Date</th>
							<th>Scant Qty</th>
							<th>Scant Amount</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in data.items" :key="item.invoice_item_no">
							<td>{{ item.so_dn }}</td>
							<td>{{ item.sales_group_name }}</td>
							<td>{{ item.class_group_code }}</td>
							<td>{{ item.dept_a_code }}</td>
							<td>{{ item.dept_b_code }}</td>
							<td>{{ item.class_code }}</td>
							<td>{{ item.item_name }}</td>
							<td>{{ item.color_code }}</td>
							<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
							<td class="al_center">{{ item.shipment_date }}</td>
							<td class="al_center">{{ item.arrival_date }}</td>
							<td class="al_right">{{ item.quantity | commaSeparated }}</td>
							<td class="al_right">{{ item.amount | toCurrency }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="bottom_bt_box">
				<ul>
					<li>
						<a href="javascript:void(0);" v-on:click="print">Print</a>
					</li>
					<li>
						<a href="javascript:void(0);" v-on:click="excel">Excel</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import CustomDatePicker from '@/components/common/CustomDatePicker';

import SalesGroup from '@/components/common/SalesGroup';
import { exportDataExcel, itemNameColorFilter, objectToUrlParam, reportMrtUrl, reportRender } from '@/api/util';
import { apiApprovedBackOrder } from '@/api/report/report';
import { today } from '@/utils/date';
import { defaultDataType } from 'export-xlsx';

export default {
	props: ['headers'],
	name: 'ApprovedBackOrder',
	components: { SalesGroup, CustomDatePicker },
	data() {
		return {
			param: {
				date: today(),
				salesGroupCode: '',
				sort: 'sc',
			},
			data: '',
		};
	},
	methods: {
		async selectData() {
			const param = objectToUrlParam(this.param);
			const { data } = await apiApprovedBackOrder(param);
			data.items.forEach(item => (item.item_name = itemNameColorFilter(item.item_name)));
			this.data = data;
		},
		async print() {
			await reportRender(this.data, 'ApprovedBackOrder', reportMrtUrl('ApprovedBackOrder'));
		},

		excel() {
			let header = [
				{ key: 'so_dn', name: 'SO NO', width: 25 },
				{ key: 'sales_group_name', name: 'Sales Name', width: 10 },
				{ key: 'class_group_code', name: 'Group', width: 10 },
				{ key: 'dept_a_code', name: 'Dept A', width: 10 },
				{ key: 'dept_b_code', name: 'Dept B', width: 10 },
				{ key: 'item_name', name: 'Name', width: 20 },
				{ key: 'color_code', name: 'Color Code', width: 15 },
				{ key: 'on_hand', name: 'OnHand', width: 15, dataType: defaultDataType.number },
				{ key: 'shipment_date', name: 'Ship Date', width: 15 },
				{ key: 'arrival_date', name: 'Arrive Date', width: 15 },
				{ key: 'quantity', name: 'Scant Qty', width: 15, dataType: defaultDataType.number },
				{ key: 'amount', name: 'Scant Amount', width: 15, dataType: defaultDataType.number },
			];
			exportDataExcel(this.data.items, header, 'Approved Back Order');
		},
	},
	mounted() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_approved_back_order');
		this.$store.commit('setSubTitle', 'Report -> Approved Back Order');
	},
};
</script>

<style scoped></style>
